import { GridItem, Paper } from './Form'
import DataSet from './DataSet'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { TransportStream } from 'common/tr101Types'

export const AdInsertionCompatibility = ({ latestTsInfo }: { latestTsInfo: TransportStream }) => {
  const supportedVideoCodecs = ['H.264', 'H.265']
  const supportedAudioCodecs = ['AAC']

  const pid256 = latestTsInfo.pids?.find((pid) => pid?.id === 256)
  const pid257 = latestTsInfo.pids?.find((pid) => pid?.id === 257)

  const gotVideo = !!pid256?.streamInfo?.video
  const gotAudio = !!pid257?.streamInfo?.audio
  const validVideoCodec = supportedVideoCodecs.find((c) => pid256?.streamInfo?.type?.description?.includes(c))
  const validAudioCodec = supportedAudioCodecs.find((c) => pid257?.streamInfo?.type?.description?.includes(c))

  const scte35Pid = latestTsInfo.pids?.find((pid) => pid?.description?.includes('SCTE-35'))

  const videoScan = pid256?.streamInfo?.video?.interlaced === 'no'

  const videoSize = pid256?.streamInfo?.video?.videoSize
  const videoSizeIsBelow4k =
    videoSize?.horizontal && videoSize?.vertical && videoSize.horizontal <= 3840 && videoSize.vertical <= 2160

  const videoFramerate = pid256?.streamInfo?.video?.frameRate
  const videoBitrate = pid256?.bitrate?.average

  const audioBitrate = pid257?.bitrate?.average

  const tests = [
    {
      label: 'PID 256 contains video',
      test: gotVideo,
    },
    {
      label: 'PID 257 contains audio',
      test: gotAudio,
    },
    {
      label: 'Video codec found',
      test: validVideoCodec,
    },
    {
      label: 'Audio codec found',
      test: validAudioCodec,
    },
    {
      label: 'SCTE35 PID found',
      test: scte35Pid,
    },
    {
      label: 'Video scan is progressive',
      test: videoScan,
    },
    {
      label: 'Video resolution found',
      test: videoSizeIsBelow4k,
    },
    {
      label: 'Framerate found',
      test: videoFramerate,
    },
    {
      label: 'Video bitrate found',
      test: videoBitrate,
    },
    {
      label: 'Audio bitrate found',
      test: audioBitrate,
    },
  ]

  const allTrue = tests.every((t) => t.test)
  const failed = tests.filter((t) => !t.test)
  const passed = tests.filter((t) => t.test)

  return (
    <Paper
      collapsible
      collapsed
      title={allTrue ? 'Stream is compatible' : `Check compatibility (${failed.length} incompatible)`}
    >
      <GridItem xs={6}>
        <DataSet
          values={{
            Incompatible: '',
            ...failed.reduce((acc, t) => ({ ...acc, [t.label]: <CloseIcon /> }), {}),
          }}
        />
      </GridItem>
      <GridItem xs={6}>
        <DataSet
          values={{
            Compatible: '',
            ...passed.reduce((acc, t) => ({ ...acc, [t.label]: <CheckIcon /> }), {}),
          }}
        />
      </GridItem>
    </Paper>
  )
}
